exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-page-query-js": () => import("./../../../src/templates/pageQuery.js" /* webpackChunkName: "component---src-templates-page-query-js" */)
}

